/// TYPES ///
import { QuoteFilter } from "api/types/quote";
/// URLS ///
import { url_prefix } from "settings";
import { quote_url } from "../../endpoint";

export function constructGetQuotesUrl(args: QuoteFilter): string {
  let url = `${url_prefix}${quote_url}/?`;

  if (args?.name && args?.name !== "") {
    url += `quote_name=${args.name}&`;
  }

  if (args?.customer_name && args?.customer_name !== "") {
    url += `customer_name=${args.customer_name}&`;
  }

  if (args?.start_date && args?.start_date !== "") {
    url += `start_date=${args.start_date}&`;
  }

  if (args?.end_date && args?.end_date !== "") {
    url += `end_date=${args.end_date}&`;
  }

  return url;
}
